import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiRequest } from '../utils/api';
import { formatSettlementReceipt } from '../utils/formatSettlementReceipt';
import '../styles/SettlementPrintView.css'; // ← 感熱紙用スタイル
import '../styles/Print.css'; // 印刷専用

function getQueryParam(search, key) {
    const params = new URLSearchParams(search);
    return params.get(key);
}

export default function SettlementPrintView() {
    const location = useLocation();
    const date = getQueryParam(location.search, 'date');
    const registerId = getQueryParam(location.search, 'register_id');
    const [printText, setPrintText] = useState('');

    useEffect(() => {
        if (!date || !registerId) return;

        const fetchData = async () => {
            try {
                const data = await apiRequest(`inventory/register_closing/print/?date=${date}&register_id=${registerId}`);
                const formatted = formatSettlementReceipt(data);
                setPrintText(formatted);
            } catch (error) {
                console.error('清算データ取得エラー:', error);
                setPrintText('データ取得に失敗しました');
            }
        };

        fetchData();
    }, [date, registerId]);

    return (
        <div className="settlement-print-container">
            <pre>{printText}</pre>
        </div>
    );
}
